import React from 'react';
import { View, StyleSheet, Platform, Text } from 'react-native';

interface LogoProps {
  size?: number;
  color?: string;
  style?: any;
}

export const LogoIcon: React.FC<LogoProps> = ({
  size = 40,
  style,
}) => {
  if (Platform.OS === 'web') {
    // Render standard inline SVG for Web platform
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        {/* Shield shape for protection */}
        <path d="M50 15 L20 30 V55 C20 75 50 90 50 90 C50 90 80 75 80 55 V30 L50 15Z" fill="#003366"/>
        {/* Document/Quote lines inside for clarity/illustration */}
        <rect x="38" y="38" width="24" height="4" rx="2" fill="#ffffff"/>
        <rect x="38" y="48" width="24" height="4" rx="2" fill="#00A651"/>
        <rect x="38" y="58" width="16" height="4" rx="2" fill="#ffffff"/>
      </svg>
    );
  }

  // Fallback for Native platform
  return (
    <View style={[styles.fallbackIcon, { width: size, height: size }, style]}>
      <Text style={styles.fallbackIconText}>eQ</Text>
    </View>
  );
};

interface FullLogoProps {
  width?: number;
  style?: any;
}

export const FullLogo: React.FC<FullLogoProps> = ({
  width = 240,
  style,
}) => {
  const height = (width * 130) / 400;

  if (Platform.OS === 'web') {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 400 130"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        {/* Shield Icon */}
        <path d="M45 25 L20 37 V57 C20 73 45 85 45 85 C45 85 70 73 70 57 V37 L45 25Z" fill="#003366"/>
        <rect x="35" y="43" width="20" height="3" rx="1.5" fill="#ffffff"/>
        <rect x="35" y="51" width="20" height="3" rx="1.5" fill="#00A651"/>
        <rect x="35" y="59" width="12" height="3" rx="1.5" fill="#ffffff"/>
        
        {/* eQuote Text */}
        <text x="90" y="70" fontFamily="'Roboto', sans-serif" fontWeight="900" fontSize="52">
          <tspan fill="#00A651">e</tspan><tspan fill="#003366">Quote</tspan>
        </text>
        
        {/* Slogan */}
        <text x="90" y="105" fontFamily="'Roboto', sans-serif" fontWeight="500" fontSize="20" fill="#666666" letterSpacing="2">
          MINH HỌA BẢO HIỂM
        </text>
      </svg>
    );
  }

  // Fallback for Native platform
  return (
    <View style={[styles.fallbackFull, { width, height }, style]}>
      <Text style={styles.fallbackTitle}><Text style={{ color: '#00A651' }}>e</Text><Text style={{ color: '#003366' }}>Quote</Text></Text>
      <Text style={styles.fallbackSub}>MINH HỌA BẢO HIỂM</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  fallbackIcon: {
    backgroundColor: '#003366',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  fallbackIconText: {
    color: '#ffffff',
    fontWeight: 'bold',
  },
  fallbackFull: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  fallbackTitle: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  fallbackSub: {
    fontSize: 10,
    color: '#666666',
    letterSpacing: 1,
  },
});
